import { Component, OnInit } from '@angular/core';
import { SentidoCirculacionService } from '../../../../../shared/services/sentido-circulacion.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpEventType } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { SedesService } from '../../../../../shared/services/sedes.service';
import { TipoViaService } from '../../../../../shared/services/tipo-via.service';
import { PropietarioService } from '../../../../../shared/services/propietarios.service';
import { AdministracionService } from '../../../../../shared/services/administracion.services';
import { PesvViasInternasService, PesvViasInternasPayload, PesvViasInternas } from '../../../../../shared/services/pesv-vias-internas.service';
import { DigitalesService } from '../../../../../shared/services/digitales.service';
import { Utils } from '../../../../../shared/utils/Utils';
import { DepartamentoService } from '../../../../../shared/services/departamentos.service';
import { DataService } from '../../../../../shared/services/municipios.service';
import { TipoSuperficieService } from '../../../../../shared/services/tipo-superficie.service';
import { EstadoSuperficieService } from '../../../../../shared/services/estado-superficie.service';

@Component({
  selector: 'app-vias-internas',
  templateUrl: './vias-internas.component.html',
  styleUrls: ['./vias-internas.component.scss'],
})
export class ViasInternasComponent implements OnInit {
  form!: FormGroup;
  guardando = false;
  idVia: number | null = null;
  activeTab = 1;
  cargandoListado = false;
  editando = false;
  vias: PesvViasInternas[] = [];
  viasFiltradas: PesvViasInternas[] = [];
  filtro = '';
  page = 1;
  pageSize = 10;
  readonly Number = Number;
  mapUrl: SafeResourceUrl | null = null;
  fotos: Array<File | null> = [null, null, null, null];
  fotosPreview: Array<string | null> = [null, null, null, null];
  readonly etiquetasFotos = ['Vista general', 'Señalización', 'Estado de la superficie', 'Acceso'];
  empresaNit: string | null = null;


  // Catálogos
  sedes: any[] = [];
  responsables: any[] = [];
  tiposVia: any[] = [];
  tiposSuperficieCatalogo: any[] = [];
  
  // Listas estáticas
  estadosSuperficie: any[] = [];
  sentidosCirculacion: any[] = [];
  pendientes = [
    '0% - Plano',
    '1% - Ligera pendiente',
    '2% - Pendiente moderada',
    '3% - Pendiente alta',
  ];
  departamentos: any[] = [];
  municipios: any[] = [];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private sedesService: SedesService,
    private tipoViaService: TipoViaService,
    private propietarioService: PropietarioService,
    private administracionService: AdministracionService,
    private viasService: PesvViasInternasService,
    private digitalesService: DigitalesService,
    private departamentoService: DepartamentoService,
    private dataService: DataService,
    private tipoSuperficieService: TipoSuperficieService,
    private sentidoCirculacionService: SentidoCirculacionService,
    private estadoSuperficieService: EstadoSuperficieService,
  ) {}

  ngOnInit(): void {
    this.inicializarForm();
    this.getSedes();
    this.getResponsables();
    this.cargarNitEmpresa();
    this.actualizarMapa();
    this.cargarVias();
    this.getDepartamentos();
    this.getMunicipios();
    this.getTiposVia();
    this.getTiposSuperficie();
    this.getEstadosSuperficie();
    this.getSentidosCirculacion();
  }

  // ===== Catálogos =====

  getSedes(): void {
    this.sedesService.getSedesVias().subscribe({
      next: (sedes) => (this.sedes = sedes),
      error: () => this.toastError('No se pudieron cargar las sedes.'),
    });
  }

  // ===== Tipos de vía =====
  getTiposVia(): void {
    this.tipoViaService.getTiposVia().subscribe({
      next: (tipos) => (this.tiposVia = tipos),
      error: () => this.toastError('No se pudieron cargar los tipos de vía.'),
    });
  }

  // ===== Responsables =====
  getResponsables(): void {
    this.propietarioService.getPlanAccion().subscribe({
      next: (propietarios) => {
        this.responsables = (propietarios || []).map((propietario: any) => ({
          ...propietario,
          nombreConCargo: `${propietario.nombreCompleto} - ${propietario.cargoData?.cargos ?? ''}`.trim(),
        }));
      },
      error: () => this.toastError('No se pudieron cargar los responsables.'),
    });
  }

  // ===== Departamentos =====
  getDepartamentos(): void {
    this.departamentoService.getTodos().subscribe({
      next: (departamentos) => (this.departamentos = departamentos),
      error: () => this.toastError('No se pudieron cargar los departamentos.'),
    });
  }

  // ===== Municipios =====
  getMunicipios(): void {
    this.dataService.getDatos().subscribe({
      next: (municipios) => (this.municipios = municipios),
      error: () => this.toastError('No se pudieron cargar los municipios.'),
    });
  }

  // ===== Tipos de superficie =====
  getTiposSuperficie(): void {
    this.tipoSuperficieService.getAll().subscribe({
      next: (tipos) => (this.tiposSuperficieCatalogo = tipos),
      error: () => this.toastError('No se pudieron cargar los tipos de superficie.'),
    });
  }

  // ===== Sentidos de circulación =====
  getSentidosCirculacion(): void {
    this.sentidoCirculacionService.getAll().subscribe({
      next: (sentidos) => (this.sentidosCirculacion = sentidos),
      error: () => this.toastError('No se pudieron cargar los sentidos de circulación.'),
    });
  }

  // ===== Estados de superficie =====
  getEstadosSuperficie(): void {
    this.estadoSuperficieService.getAll().subscribe({
      next: (estados) => (this.estadosSuperficie = estados),
      error: () => this.toastError('No se pudieron cargar los estados de superficie.'),
    });
  }


  private cargarNitEmpresa(): void {
    this.administracionService.obtenerTodas().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta)
          ? respuesta
          : Array.isArray(respuesta?.administraciones)
            ? respuesta.administraciones
            : [];
        this.empresaNit = lista[0]?.nit?.toString() || null;

        if (this.editando && this.idVia) {
          this.cargarFotosExistentes(this.idVia);
        }
      },
      error: () => (this.empresaNit = null),
    });
  }

  cargarVias(): void {
    if (this.cargandoListado) return;

    this.cargandoListado = true;
    this.viasService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta) ? respuesta : respuesta?.data;
        this.vias = Array.isArray(lista) ? lista : [];
        this.aplicarFiltro();
        this.cargandoListado = false;
      },
      error: () => {
        this.vias = [];
        this.viasFiltradas = [];
        this.cargandoListado = false;
        this.toastError('No se pudieron cargar las vías registradas.');
      },
    });
  }

  aplicarFiltro(): void {
    const termino = this.filtro.trim().toLowerCase();
    this.viasFiltradas = this.vias.filter((via: any) => {
      if (!termino) return true;
      return [via.codigo, via.nombre, via.tipo_via, via.municipio, via.estado]
        .some((valor) => String(valor ?? '').toLowerCase().includes(termino));
    });
    this.page = 1;
  }

  mostrarListado(): void {
    if (this.activeTab === 2) return;
    this.activeTab = 2;
  }

  editarVia(via: PesvViasInternas): void {
    if (!via?.id) return;
    this.viasService.getById(via.id).subscribe({
      next: (respuesta: any) => {
        const datos = respuesta?.data ?? respuesta;
        this.idVia = Number(datos.id ?? via.id);
        this.editando = true;
        this.limpiarFotos();
        this.form.patchValue({
          sede: this.valorCatalogo(datos.sede_id ?? datos.sede),
          nombre: datos.nombre,
          tipo_via: this.valorCatalogo(datos.tipo_via_id ?? datos.tipo_via),
          codigo: datos.codigo,
          responsable: this.valorCatalogo(datos.responsable_id ?? datos.responsable),
          cargo: datos.cargo ?? datos.responsableData?.cargoData?.cargos ?? null,
          fecha_registro: this.normalizarFecha(datos.fecha_registro ?? datos.fechaRegistro ?? datos.fechaCreacion),
          descripcion: datos.descripcion,
          longitud_m: datos.longitud_m,
          ancho_m: datos.ancho_m,
          numero_carriles: datos.numero_carriles,
          sentido_circulacion: datos.sentido_circulacion,
          tipo_superficie: this.valorCatalogo(datos.tipo_superficie_id ?? datos.tipo_superficie),
          estado_superficie: this.valorCatalogo(datos.estado_superficie),
          pendiente: datos.pendiente,
          velocidad_maxima_kmh: datos.velocidad_maxima_kmh,
          direccion: datos.direccion,
          municipio: this.valorCatalogo(datos.municipio_id ?? datos.municipio),
          departamento: this.valorCatalogo(datos.departamento_id ?? datos.departamento),
          latitud: datos.latitud,
          longitud: datos.longitud,
          estado: datos.estado ?? 1,
        });
        this.seleccionarResponsable(this.form.get('responsable')?.value);
        this.actualizarMapa();
        this.cargarFotosExistentes(this.idVia);
        this.activeTab = 1;
      },
      error: () => this.toastError('No se pudo cargar la vía para editar.'),
    });
  }

  nuevaVia(): void {
    this.idVia = null;
    this.editando = false;
    this.form.reset({ estado: 1 });
    this.limpiarFotos();
    this.actualizarMapa();
    this.activeTab = 1;
  }

  cambiarEstado(via: PesvViasInternas): void {
    if (!via.id) return;
    const activar = Number(via.estado) !== 1;

    Swal.fire({
      icon: 'warning',
      title: `${activar ? 'Activar' : 'Inactivar'} vía`,
      text: `¿Está seguro de ${activar ? 'activar' : 'inactivar'} esta vía?`,
      showCancelButton: true,
      confirmButtonText: `Sí, ${activar ? 'activar' : 'inactivar'}`,
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    }).then((resultado) => {
      if (!resultado.isConfirmed) return;

      const accion$ = activar
        ? this.viasService.activar(via.id as number)
        : this.viasService.inactivar(via.id as number);
      accion$.subscribe({
        next: () => {
          Swal.fire({
            icon: 'success',
            title: activar ? 'Vía activada' : 'Vía inactivada',
            text: `La vía fue ${activar ? 'activada' : 'inactivada'} correctamente.`,
            timer: 1600,
            showConfirmButton: false,
          });
          this.cargarVias();
        },
        error: () => this.toastError(`No se pudo ${activar ? 'activar' : 'inactivar'} la vía.`),
      });
    });
  }

  private normalizarFecha(fecha: any): string | null {
    if (!fecha) return null;
    const valor = String(fecha);
    if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) return valor;
    const fechaConvertida = new Date(fecha);
    if (Number.isNaN(fechaConvertida.getTime())) return null;
    return fechaConvertida.toISOString().split('T')[0];
  }

  seleccionarResponsable(cedula: number): void {
    const responsable = this.responsables.find((item) => String(item.cedula) === String(cedula));
    this.form.patchValue({
      cargo: responsable?.cargoData?.cargos ?? null,
    });
  }

  private valorCatalogo(valor: any): any {
    if (valor == null || typeof valor !== 'object') return valor;
    return valor.id ?? valor.ID ?? valor.IDMUN ?? valor.id_departamento ?? valor.cedula ?? valor.codigo ?? valor.nombre ?? valor.descripcion;
  }

  seleccionarFoto(event: Event, indice: number): void {
    const input = event.target as HTMLInputElement;
    const archivo = input.files?.[0];
    if (!archivo) return;

    if (!archivo.type.startsWith('image/')) {
      this.toastError('Solo se permiten archivos de imagen.');
      input.value = '';
      return;
    }

    if (archivo.size > 10 * 1024 * 1024) {
      this.toastError('La imagen no debe superar los 10 MB.');
      input.value = '';
      return;
    }

    if (this.fotosPreview[indice]) {
      URL.revokeObjectURL(this.fotosPreview[indice] as string);
    }
    this.fotos[indice] = archivo;
    this.fotosPreview[indice] = URL.createObjectURL(archivo);
  }

private subirFotos(idVia: number): Observable<string[]> {
  if (!this.empresaNit) {
    return of<string[]>([]); // o maneja el error como prefieras
  }
  const carpeta = `${this.empresaNit}/pesv/vias-internas/${idVia}`;
  const cargas = this.fotos
    .map((archivo, indice) => {
      if (!archivo) return null;
      const extension = archivo.name.split('.').pop()?.toLowerCase() || 'jpg';
      const nombre = `VIA_${idVia}_${indice + 1}.${extension}`;
      return this.digitalesService.subirArchivo(archivo, idVia, carpeta, nombre, 'VIAS').pipe(
        filter((evento) => evento.type === HttpEventType.Response),
        map((): string => nombre),
      );
    })
    .filter((carga) => carga !== null) as Observable<string>[];

  return cargas.length ? forkJoin(cargas) : of<string[]>([]);
}

  private limpiarFotos(): void {
    this.fotosPreview.forEach((preview) => {
      if (preview) URL.revokeObjectURL(preview);
    });
    this.fotos = [null, null, null, null];
    this.fotosPreview = [null, null, null, null];
  }

private cargarFotosExistentes(idVia: number): void {
  if (!this.empresaNit) return;

  const carpeta = `${this.empresaNit}/pesv/vias-internas/${idVia}`;
  this.digitalesService.getDocumentosPlanAccion(carpeta).subscribe({
    next: (respuesta: any) => {
      const imagenes = (respuesta?.archivos ?? [])
        .filter((archivo: any) => this.esImagenPorNombre(archivo.name));

      this.fotosPreview = [null, null, null, null];
      imagenes.forEach((imagen: any) => {
        const indice = this.indiceFoto(imagen.name) - 1; // los nombres son VIA_x_1 → índice 0
        if (indice >= 0 && indice < this.fotosPreview.length) {
          this.fotosPreview[indice] = imagen.url;
        }
      });
    },
    error: () => {
      this.fotosPreview = [null, null, null, null];
    },
  });
}

  private esImagenPorNombre(nombre: string): boolean {
    const extension = nombre?.split('.').pop()?.toLowerCase() ?? '';
    return ['jpg', 'jpeg', 'png', 'webp'].includes(extension);
  }

  private indiceFoto(nombre: string): number {
    const indice = Number(nombre?.match(/VIA_\d+_(\d+)/i)?.[1]);
    return Number.isFinite(indice) ? indice : Number.MAX_SAFE_INTEGER;
  }

  // ng-select con bindValue puede recibir ids como number desde el catálogo
  // y como string desde un getById; este comparator evita que el select
  // se muestre vacío en modo edición.
  compararIds = (a: any, b: any): boolean => a != null && b != null && String(a) === String(b);

  actualizarMapa(): void {
    const latitud = Number(this.form.get('latitud')?.value);
    const longitud = Number(this.form.get('longitud')?.value);

    if (!Number.isFinite(latitud) || !Number.isFinite(longitud) ||
      latitud < -90 || latitud > 90 || longitud < -180 || longitud > 180) {
      this.mapUrl = null;
      return;
    }

    const delta = 0.01;
    const bbox = `${longitud - delta},${latitud - delta},${longitud + delta},${latitud + delta}`;
    const url = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${latitud},${longitud}`;
    this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  // ===== Formulario =====

  inicializarForm(): void {
    this.form = this.fb.group({
      sede: [null, Validators.required],
      nombre: [null, Validators.required],
      tipo_via: [null, Validators.required],
      codigo: [null, Validators.required],
      fecha_registro: [null, Validators.required],
      responsable: [null, Validators.required],
      cargo: [null],
      descripcion: [null, Validators.required],

      longitud_m: [null, [Validators.required, Validators.min(0)]],
      ancho_m: [null, [Validators.required, Validators.min(0)]],
      numero_carriles: [null, [Validators.required, Validators.min(1)]],
      sentido_circulacion: [null, Validators.required],
      tipo_superficie: [null, Validators.required],
      estado_superficie: [null, Validators.required],
      pendiente: [null, Validators.required],
      velocidad_maxima_kmh: [null, [Validators.required, Validators.min(0)]],

      direccion: [null, Validators.required],
      municipio: [null, Validators.required],
      departamento: [null, Validators.required],
      latitud: [null, Validators.required],
      longitud: [null, Validators.required],

      estado: [1],
    });
  }


  // ===== Guardado =====

  guardar(continuar = false): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      const camposInvalidos = Object.keys(this.form.controls)
        .filter((campo) => this.form.get(campo)?.invalid)
        .join(', ');
      Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: `Revisa los siguientes campos: ${camposInvalidos}.`,
      });
      return;
    }

    const valores = this.form.getRawValue();
    const payload: PesvViasInternasPayload = {
      ...valores,
      sede_id: valores.sede,
      responsable_id: valores.responsable,
    };
    delete (payload as any).sede;
    delete (payload as any).responsable;
    delete (payload as any).cargo;
    delete (payload as any).fecha_registro;
    this.guardando = true;

    const peticion$ = this.idVia
      ? this.viasService.update(this.idVia, payload)
      : this.viasService.create(payload);

    peticion$.subscribe({
      next: (respuesta: any) => {
        const idGuardado = this.idVia ?? respuesta?.id ?? respuesta?.data?.id;
        if (!idGuardado) {
          this.guardando = false;
          this.toastError('La vía se guardó, pero no se recibió su identificador para cargar las imágenes.');
          return;
        }

        this.subirFotos(Number(idGuardado)).subscribe({
          next: () => this.finalizarGuardado(continuar),
          error: () => {
            this.guardando = false;
            this.toastError('La vía se guardó, pero una o más imágenes no pudieron cargarse.');
          },
        });
      },
      error: (err) => {
        this.guardando = false;
        this.toastError(err?.error?.message ?? 'Ocurrió un error al guardar la vía.');
      },
    });
  }

  private finalizarGuardado(continuar: boolean): void {
    this.guardando = false;
    Swal.fire({
      icon: 'success',
      title: this.idVia ? 'Vía actualizada' : 'Vía registrada',
      text: 'La información y las imágenes se guardaron correctamente.',
      timer: 1800,
      showConfirmButton: false,
    });

    if (continuar && !this.idVia) {
      const sede = this.form.get('sede')?.value;
      this.form.reset({ sede, estado: 1 });
      this.limpiarFotos();
    } else {
      this.cargarVias();
      this.editando = false;
      this.idVia = null;
      this.activeTab = 2;
    }
  }

  guardarYContinuar(): void {
    this.guardar(true);
  }

  cancelar(): void {
    this.nuevaVia();
    this.activeTab = 2;
    this.cargarVias();
  }

  private toastError(mensaje: string): void {
    Swal.fire({ icon: 'error', title: 'Error', text: mensaje });
  }

  exportarExcel(): void {
    Utils.exportVisibleTableToExcel(
      'tblViasInternas',
      'listado_vias_internas',
      'Vías internas',
    );
  }

  exportarPdf(): void {
    Utils.exportToPDF(
      'tblViasInternas',
      'listado_vias_internas',
      'Listado de vías internas',
      true,
    );
  }
}